// Per-section appearance defaults (height = vertical padding in px, text = base font size in px).
// Text elements inside sections use em units, so they scale with this base font size.
export const APPR_DEFAULTS = {
  hero: { h: 40, t: 16 },
  zielgruppen: { h: 88, t: 16 },
  leistungen: { h: 88, t: 16 },
  problem: { h: 88, t: 16 },
  ablauf: { h: 88, t: 16 },
  inhaber: { h: 88, t: 16 },
  partner: { h: 72, t: 16 },
  regulatorik: { h: 88, t: 16 },
  partnerstimmen: { h: 88, t: 16 },
  kundenstimmen: { h: 88, t: 16 },
  kontakt: { h: 88, t: 16 },
  faq: { h: 88, t: 16 },
};

// The 5-colour palette (adjustable in the admin). Keys are stable; values are editable.
export const PALETTE_KEYS = ["weiss", "hellgrau", "mittelgrau", "dunkelgrau", "schwarz"];
export const PALETTE_LABELS = {
  weiss: "Weiß", hellgrau: "Hellgrau", mittelgrau: "Mittelgrau", dunkelgrau: "Dunkelgrau", schwarz: "Schwarz",
};
export const PALETTE_DEFAULT = {
  weiss: "#ffffff",
  hellgrau: "#f4f3f1",
  mittelgrau: "#bdbcb8",
  dunkelgrau: "#9d9c98",
  schwarz: "#17171a",
};

// Default background palette key per section (matches the current design).
export const BG_DEFAULTS = {
  hero: "mittelgrau",
  zielgruppen: "dunkelgrau",
  leistungen: "weiss",
  problem: "schwarz",
  ablauf: "mittelgrau",
  inhaber: "weiss",
  partner: "schwarz",
  regulatorik: "weiss",
  partnerstimmen: "hellgrau",
  kundenstimmen: "weiss",
  kontakt: "weiss",
  faq: "hellgrau",
};

export function getPalette(settings) {
  return { ...PALETTE_DEFAULT, ...((settings && settings.palette) || {}) };
}

function hexToRgb(hex) {
  let h = String(hex || "").replace("#", "").trim();
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  const n = parseInt(h, 16);
  if (Number.isNaN(n)) return [255, 255, 255];
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

// Perceived brightness (0..1). Colours below the threshold get light text.
export function isDarkColor(hex) {
  const [r, g, b] = hexToRgb(hex);
  return (r * 0.299 + g * 0.587 + b * 0.114) / 255 < 0.5;
}

export function defaultAppr(key) {
  return APPR_DEFAULTS[key] || { h: 88, t: 16 };
}

// Resolve a section's appearance from settings, falling back to defaults.
export function apprOf(settings, key) {
  const d = defaultAppr(key);
  const a = ((settings && settings.appearance) || {})[key] || {};
  const h = Number.isFinite(a.h) ? a.h : d.h;
  const t = Number.isFinite(a.t) ? a.t : d.t;
  const palette = getPalette(settings);
  const bgKey = a.bg && palette[a.bg] ? a.bg : (BG_DEFAULTS[key] || "weiss");
  const bg = palette[bgKey];
  const dark = isDarkColor(bg);
  return {
    h, t, bgKey, bg, dark,
    style: { paddingTop: `${h}px`, paddingBottom: `${h}px`, fontSize: `${t}px`, backgroundColor: bg },
  };
}
